import { htmlEncode } from "@/utils/htmlUtils";
import {
  UNLIMITED,
  PPU_INDEX,
  allKindProduct,
  USAGE_TEXT,
  USAGE_TYPES,
  PREPAID,
  PREPAID_TARIFFS,
  PREPAID_TARIFFS_NOT_RENEWED,
  PREPAID_TARIFFS_NOT_USAGES,
} from "@/constants/constants";
import { usageIntervals } from "@/constants/setupBasics";
import { TEXT_TYPES_CODES } from "@/constants/catalogue";
import { getProductNameOfferingByType } from "./dataHandlers/CatalogueDataHandler";
import { transformMeasureUnits } from "./dataHandlers/Transformers";
import {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
} from "@/bit/components/components.text";

export const convertNCleanOtherLabel = (initialLabel) => {
  const labelToReturn = initialLabel.split("|").join(" ").trim();
  return htmlEncode(labelToReturn);
};

export const returnElemWithKeyAndValue = (array, key, value) => {
  const numberOfItems = array.length;
  for (let a = 0; a < numberOfItems; a += 1) {
    const currentItem = array[a];
    if (typeof currentItem[key] !== "undefined" && currentItem[key] !== null) {
      if (currentItem[key] === value) {
        return currentItem;
      }
    }
  }
  return null;
};

/* END OF AUXILIAR FUNCTIONS FOR DONUT LIST */
export const getColorAndPercentageByUsageData = (
  consumedData,
  maxValueData
) => {
  let color;
  let percentage = 0;

  if (maxValueData === UNLIMITED) {
    percentage = -2;
    return {
      color: "unlimited",
      percentage,
    };
  }

  if (maxValueData === PPU_INDEX) {
    percentage = -2;
    return {
      color: "payPerUse",
      percentage,
    };
  }

  if (consumedData !== 0 || maxValueData === 0) {
    percentage = (consumedData * 100) / maxValueData;
    percentage = parseInt(percentage.toFixed(2), 10);
    percentage = percentage < 1 ? 1 : percentage;
  }
  /* Calculo del color si no esta definido */
  Object.keys(usageIntervals).forEach((percentageInterval) => {
    if (percentage >= parseInt(percentageInterval, 10)) {
      color = usageIntervals[percentageInterval];
    }
  });

  return {
    color,
    percentage,
  };
};

// Funciones de conversión
export const transformKbtoData = (kb) => {
  if (kb === 0) {
    return 0; // Si kb es 0, devuelve 0 directamente
  }
  if (kb === PPU_INDEX) {
    return PPU_INDEX;
  }

  if (kb === UNLIMITED) {
    return UNLIMITED;
  }

  return transformMeasureUnits("kb", kb);
};

export const convertirBasics = (unidad) => {
  if (unidad === 0) {
    return 0; // Si kb es 0, devuelve 0 directamente
  }
  if (unidad === PPU_INDEX) {
    return PPU_INDEX;
  }

  if (unidad === UNLIMITED) {
    return UNLIMITED;
  }
  return Math.floor(unidad); // Redondear hacia abajo
};

export const convertirSecondsToMinutes = (seconds) => {
  if (seconds === 0) {
    return 0;
  }
  if (seconds === PPU_INDEX) {
    return PPU_INDEX;
  }
  if (seconds === UNLIMITED) {
    return UNLIMITED;
  }

  const minutos = seconds / 60;
  return Math.floor(minutos); // Redondear hacia abajo
};

export const getAllBonusDataByAccumulatedFb = (usageType) => {
  const usagesFb = [];
  const bonuFb = usageType.bonus.filter(
    (bonu) => bonu.fb && bonu.maxValue !== 50
  );
  
  if (bonuFb && Array.isArray(bonuFb) && bonuFb.length > 0) {
    bonuFb.forEach((bonu) => {
      const newData = {
        ...usageType,
      };
      newData.type = !bonu.info ? USAGE_TYPES.datos : USAGE_TYPES.info;
      if (bonu.info) {
        newData.info = bonu.info;
      }
      newData.currentInKb = bonu.current;
      newData.maxValueInKb = bonu.maxValue;
      newData.mainTitle = USAGE_TEXT.datos;
      newData.unit = bonu.current === 0 ? USAGE_TEXT.kb : "";
      newData.current = transformKbtoData(bonu.current);
      newData.maxValue = transformKbtoData(bonu.maxValue);
      usagesFb.push(newData);
    });
  }
  return usagesFb;
};

export const getAllBonusDataByAccumulatedNotFb = (usageType) => {
  const usagesNotFb = [];
  const bonuNotFb = usageType.bonus.filter((bonu) => !bonu.fb);
  if (bonuNotFb && Array.isArray(bonuNotFb) && bonuNotFb.length > 0) {
    bonuNotFb.forEach((bonu) => {
      const newData = {
        ...usageType,
      };
      newData.type = !bonu.info ? USAGE_TYPES.datos : USAGE_TYPES.info;
      if (bonu.info) {
        newData.info = bonu.info;
      }
      newData.currentInKb = bonu.current;
      newData.maxValueInKb = bonu.maxValue;
      newData.mainTitle = bonu.description;
      newData.unit = bonu.current === 0 ? USAGE_TEXT.kb : "";
      newData.current = transformKbtoData(bonu.current);
      newData.maxValue = transformKbtoData(bonu.maxValue);
      usagesNotFb.push(newData);
    });
  }
  return usagesNotFb;
};

export const getAllBonusDataByAccumulated = (usageType) => {
  let usages = [];
  if (
    usageType &&
    usageType.bonus &&
    Array.isArray(usageType.bonus) &&
    usageType.bonus.length > 0
  ) {
    const usagesFb = getAllBonusDataByAccumulatedFb(usageType);
    const usagesNotFb = getAllBonusDataByAccumulatedNotFb(usageType);
    usages.push(...usagesFb, ...usagesNotFb);
  } else if (usageType) {
    usageType.type = USAGE_TYPES.datos;
    usageType.currentInKb = usageType.current;
    usageType.maxValueInKb = usageType.maxValue;
    usageType.mainTitle = USAGE_TEXT.datos;
    usageType.unit = usageType.current === 0 ? USAGE_TEXT.kb : "";
    usageType.current = transformKbtoData(usageType.current);
    usageType.maxValue = transformKbtoData(usageType.maxValue);
    if (usageType.ppu) {
      usageType.ppu.unit = usageType.ppu.current === 0 ? USAGE_TEXT.kb : "";
      usageType.ppu.current = transformKbtoData(usageType.ppu.current);
      usageType.ppu.maxValue = transformKbtoData(usageType.ppu.maxValue);
    }
    usages.push(usageType);
  }
  return usages;
};

export const getAllBonusVoiceByAccumulatedFb = (usageType) => {
  const usagesFb = [];
  const bonuFb = usageType.bonus.filter((bonu) => bonu.fb);
  if (bonuFb && Array.isArray(bonuFb) && bonuFb.length > 0) {
    bonuFb.forEach((bonu) => {
      const newData = {
        ...usageType,
      };
      newData.type = USAGE_TYPES.voice;
      newData.mainTitle = bonu.description;
      newData.unit = USAGE_TEXT.min;
      newData.current = convertirSecondsToMinutes(bonu.current);
      newData.maxValue = convertirSecondsToMinutes(bonu.maxValue);
      usagesFb.push(newData);
    });
  }
  return usagesFb;
};

export const getAllBonusVoiceByAccumulatedNotFb = (usageType) => {
  const usagesNotFb = [];
  const bonuNotFb = usageType.bonus.filter((bonu) => !bonu.fb);
  if (bonuNotFb && Array.isArray(bonuNotFb) && bonuNotFb.length > 0) {
    bonuNotFb.forEach((bonu) => {
      const newData = {
        ...usageType,
      };
      newData.type = USAGE_TYPES.voice;
      newData.mainTitle = bonu.description;
      newData.unit = USAGE_TEXT.min;
      newData.current = convertirSecondsToMinutes(bonu.current);
      newData.maxValue = convertirSecondsToMinutes(bonu.maxValue);
      usagesNotFb.push(newData);
    });
  }
  return usagesNotFb;
};

export const getAllBonusVoiceByAccumulated = (usageType) => {
  let usages = [];
  if (
    usageType &&
    usageType.bonus &&
    Array.isArray(usageType.bonus) &&
    usageType.bonus.length > 0
  ) {
    const usagesFb = getAllBonusVoiceByAccumulatedFb(usageType);
    const usagesNotFb = getAllBonusVoiceByAccumulatedNotFb(usageType);
    usages.push(...usagesFb, ...usagesNotFb);
  } else if (usageType) {
    usageType.type = USAGE_TYPES.voice;
    usageType.mainTitle = USAGE_TEXT.llamadas;
    usageType.unit = USAGE_TEXT.min;
    usageType.current = convertirSecondsToMinutes(usageType.current);
    usageType.maxValue = convertirSecondsToMinutes(usageType.maxValue);
    if (usageType.ppu) {
      usageType.ppu.unit = USAGE_TEXT.min;
      usageType.ppu.current = convertirSecondsToMinutes(usageType.ppu.current);
      usageType.ppu.maxValue = convertirSecondsToMinutes(
        usageType.ppu.maxValue
      );
    }
    usages.push(usageType);
  }
  return usages;
};

export const getAllBonusSmsByAccumulatedFb = (usageType) => {
  const usagesFb = [];
  const bonuFb = usageType.bonus.filter((bonu) => bonu.fb);
  if (bonuFb && Array.isArray(bonuFb) && bonuFb.length > 0) {
    bonuFb.forEach((bonu) => {
      const newData = {
        ...usageType,
      };
      newData.type = USAGE_TYPES.sms;
      newData.mainTitle = bonu.description;
      newData.unit = USAGE_TEXT.sms;
      newData.current = convertirBasics(bonu.current);
      newData.maxValue = convertirBasics(bonu.maxValue);
      usagesFb.push(newData);
    });
  }
  return usagesFb;
};

export const getAllBonusSmsByAccumulatedNotFb = (usageType) => {
  const usagesNotFb = [];
  const bonuNotFb = usageType.bonus.filter((bonu) => !bonu.fb);
  if (bonuNotFb && Array.isArray(bonuNotFb) && bonuNotFb.length > 0) {
    bonuNotFb.forEach((bonu) => {
      const newData = {
        ...usageType,
      };
      newData.type = USAGE_TYPES.sms;
      newData.mainTitle = bonu.description;
      newData.unit = USAGE_TEXT.sms;
      newData.current = convertirBasics(bonu.current);
      newData.maxValue = convertirBasics(bonu.maxValue);
      usagesNotFb.push(newData);
    });
  }
  return usagesNotFb;
};

export const getAllBonusSmsByAccumulated = (usageType) => {
  let usages = [];
  if (
    usageType &&
    usageType.bonus &&
    Array.isArray(usageType.bonus) &&
    usageType.bonus.length > 0
  ) {
    const usagesFb = getAllBonusSmsByAccumulatedFb(usageType);
    const usagesNotFb = getAllBonusSmsByAccumulatedNotFb(usageType);
    usages.push(...usagesFb, ...usagesNotFb);
  } else if (usageType) {
    usageType.type = USAGE_TYPES.sms;
    usageType.mainTitle = USAGE_TEXT.messages;
    usageType.unit = USAGE_TEXT.sms;
    usageType.current = convertirBasics(usageType.current);
    usageType.maxValue = convertirBasics(usageType.maxValue);
    if (usageType.ppu) {
      usageType.ppu.unit = USAGE_TEXT.sms;
      usageType.ppu.current = convertirBasics(usageType.ppu.current);
      usageType.ppu.maxValue = convertirBasics(usageType.ppu.maxValue);
    }
    usages.push(usageType);
  }
  return usages;
};

export const getDataUsagesByAccumulated = (usageType) => {
  let dataUsages = null;
  if (usageType) {
    dataUsages = {
      ...usageType,
    };
    dataUsages.type = USAGE_TYPES.datos;
    dataUsages.currentInKb = usageType.current;
    dataUsages.maxValueInKb = usageType.maxValue;
    dataUsages.mainTitle = USAGE_TEXT.datos;
    dataUsages.unit = usageType.current === 0 ? USAGE_TEXT.kb : "";
    dataUsages.current = transformKbtoData(usageType.current);
    dataUsages.maxValue = transformKbtoData(usageType.maxValue);
    dataUsages.consumed = true;
    if (dataUsages.ppu) {
      dataUsages.ppu.unit = usageType.ppu.current === 0 ? USAGE_TEXT.kb : "";
      dataUsages.ppu.current = transformKbtoData(usageType.ppu.current);
      dataUsages.ppu.maxValue = transformKbtoData(usageType.ppu.maxValue);
    }
  }
  return dataUsages;
}

export const getVoiceUsagesByAccumulated = (usageType) => {
  let voiceUsages = null;
  if (usageType) {
    voiceUsages = {
      ...usageType
    }
    voiceUsages.type = USAGE_TYPES.voice;
    voiceUsages.mainTitle = USAGE_TEXT.llamadas;
    voiceUsages.unit = USAGE_TEXT.min;
    voiceUsages.current = convertirSecondsToMinutes(usageType.current);
    voiceUsages.maxValue = convertirSecondsToMinutes(usageType.maxValue);
    voiceUsages.consumed = true;
    if (voiceUsages.ppu) {
      voiceUsages.ppu.unit = USAGE_TEXT.min;
      voiceUsages.ppu.current = convertirSecondsToMinutes(usageType.ppu.current);
      voiceUsages.ppu.maxValue = convertirSecondsToMinutes(
        usageType.ppu.maxValue
      );
    }
  }
  return voiceUsages;
};

export const generateProducts = (
  productData,
  accumulatedUsagesData,
  period,
  catalogueProductOffering,
  orionProduct,
  sharedData,
  productSharedData
) => {
  let products = [];

  // Iteración sobre accumulatedUsages
  for (let i = 0; i < accumulatedUsagesData.length; i++) {
    const productDataToShow = productData.filter(
      (data) => data.productId === accumulatedUsagesData[i].productId
    );

    if (productDataToShow.length > 0) {
      const isPrepaid = productData[0].type === PREPAID;
      let expiredTariff = false;
      let infoToShow = {};
      infoToShow.expired = expiredTariff;
      infoToShow.kindProduct = productDataToShow[0].kindProduct;
      infoToShow.title =
        productDataToShow[0].kindProduct === allKindProduct.tv
          ? USAGE_TEXT.tv
          : productDataToShow[0].number;
      const currentOrionProduct = Array.isArray(orionProduct) && orionProduct.length > 0 && orionProduct.find((product) => product.poId === productDataToShow[0].poId);
      const catalogOrionText = getProductNameOfferingByType({
        catalogueProductOffering,
        textType: TEXT_TYPES_CODES.ORDINARY,
        poId: productDataToShow[0].poId,
      });
      infoToShow.subtitle =
        (currentOrionProduct?.title) ||
        (catalogOrionText && catalogOrionText[0] && catalogOrionText[0].text) ||
        productData[0].name;
      
      let idTarifa = '';
      if (isPrepaid) {
        infoToShow.subtitle = accumulatedUsagesData[i].period[period].rate;
        idTarifa = accumulatedUsagesData[i].period[period].id;
        infoToShow.idTarifa = idTarifa;
        expiredTariff = accumulatedUsagesData[i].period[period].expired;
        if (expiredTariff) {
          infoToShow.expired = expiredTariff;
          infoToShow.additionalInfo = {
            icon: "alerta-m",
            text: PREPAID_TARIFFS_NOT_RENEWED
          }
        }
      }
      infoToShow.productId = accumulatedUsagesData[i].productId;
      infoToShow.href = `/area-cliente/mis-productos/consumos/detalle?productId=${accumulatedUsagesData[i].productId}&period=${period}`;

      let usages = [];
      let voice = accumulatedUsagesData[i].period[period].voice || null;
      let data = accumulatedUsagesData[i].period[period].data || null;
      // let dataRoaming =
      //   accumulatedUsagesData[i].period[period].dataRoaming || null;
      // let sms = accumulatedUsagesData[i].period[period].sms || null;
      let dataUsages = null;
      let voiceUsages = null;
      // let allBonusSms = [];

      const isProductSharedData = productSharedData && Array.isArray(productSharedData) && productSharedData.length > 0;

      if ((!idTarifa || idTarifa !== PREPAID_TARIFFS.HABLA_6) && !expiredTariff) {
        if (!isProductSharedData) {
          dataUsages = getDataUsagesByAccumulated(data);
        }
        voiceUsages = getVoiceUsagesByAccumulated(voice);
        // allBonusSms = getAllBonusSmsByAccumulated(sms);
      }

      // if (dataRoaming) {
      //   dataRoaming.type = USAGE_TYPES.datos;
      //   dataRoaming.currentInKb = dataRoaming.current;
      //   dataRoaming.maxValueInKb = dataRoaming.maxValue;
      //   dataRoaming.mainTitle = USAGE_TEXT.Roaming2;
      //   dataRoaming.unit = dataRoaming.current === 0 ? USAGE_TEXT.kb : "";
      //   dataRoaming.current = transformKbtoData(dataRoaming.current);
      //   dataRoaming.maxValue = transformKbtoData(dataRoaming.maxValue);
      //   if (dataRoaming.ppu) {
      //     dataRoaming.ppu.unit =
      //       dataRoaming.ppu.current === 0 ? USAGE_TEXT.kb : "";
      //     dataRoaming.ppu.current = transformKbtoData(dataRoaming.ppu.current);
      //     dataRoaming.ppu.maxValue = transformKbtoData(
      //       dataRoaming.ppu.maxValue
      //     );
      //   }
      // }

      let newProductSharedData = null;
      if (isProductSharedData && data) {
        const current = transformKbtoData(data.current);
        const unit = data.current === 0 ? USAGE_TEXT.kb : "";
        newProductSharedData = {
          ...productSharedData[0],
          textUnderUsageBar: `${current}${unit ? ` ${unit}` : ''} esta línea`,
        }
        // productSharedData[0].textUnderUsageBar = `${current}${unit ? ` ${unit}` : ''} esta línea`
      }

      if (productDataToShow[0].kindProduct !== allKindProduct.tv) {
        voiceUsages && usages.push(voiceUsages);
        if (productDataToShow[0].kindProduct !== allKindProduct.phone) {
          dataUsages && usages.push(dataUsages);
          newProductSharedData && usages.push(newProductSharedData);
          // dataRoaming && usages.push(dataRoaming);
          // allBonusSms && usages.push(...allBonusSms);
        }
      } else if (productDataToShow[0].kindProduct === allKindProduct.tv) {
        infoToShow.TV = accumulatedUsagesData[i].period[period].others.current;
      }

      infoToShow.usages = usages;
      infoToShow.extra = accumulatedUsagesData[i].period[period]?.totalExtra;
      console.log(infoToShow, "info");
      products.push(infoToShow);
    }
  }

  // Ordenar productos colocando 'tv' al final
  products = products.sort((a, b) => {
    if (
      a.kindProduct === allKindProduct.tv &&
      b.kindProduct !== allKindProduct.tv
    ) {
      return 1;
    } else if (
      a.kindProduct !== allKindProduct.tv &&
      b.kindProduct === allKindProduct.tv
    ) {
      return -1;
    } else {
      return 0;
    }
  });

  return products;
};

export const generateProductsDetails = (
  productData,
  accumulatedUsagesData,
  period = 0,
  catalogueProductOffering,
  orionProduct,
  productId,
  productSharedData,
) => {
  let products = null;

  if (productData) {
    const isPrepaid = accumulatedUsagesData.type === PREPAID;
    let expiredTariff = false;
    let infoToShow = {};
    infoToShow.expired = expiredTariff;
    infoToShow.kindProduct = productData.kindProduct;
    infoToShow.title =
      productData.kindProduct === allKindProduct.tv
        ? USAGE_TEXT.tv
        : productData.number;
    const currentOrionProduct = Array.isArray(orionProduct) && orionProduct.length > 0 && orionProduct.find((product) => product.poId === productData.poId);
    const catalogOrionText = getProductNameOfferingByType({
      catalogueProductOffering,
      textType: TEXT_TYPES_CODES.ORDINARY,
      poId: productData.poId,
    });
    infoToShow.subtitle =
      (currentOrionProduct?.title) ||
      (catalogOrionText && catalogOrionText[0] && catalogOrionText[0].text) ||
      productData.name;
    let idTarifa = '';
    if (isPrepaid) {
      infoToShow.subtitle = accumulatedUsagesData.period[period].rate;
      idTarifa = accumulatedUsagesData.period[period].id;
      infoToShow.idTarifa = idTarifa;
      expiredTariff = accumulatedUsagesData.period[period].expired;
      if (idTarifa === PREPAID_TARIFFS.HABLA_6 || expiredTariff) {
        infoToShow.additionalMessage = {
          text: PREPAID_TARIFFS_NOT_USAGES,
        }
      }
      if (expiredTariff) {
        infoToShow.expired = expiredTariff;
        infoToShow.alertInfo = {
          icon: {
            name: "alerta-m",
            color: TEXT_COLOR.GREY5, 
            height: "16px",
            width: "16px",
          },
          textProps: {
            text: PREPAID_TARIFFS_NOT_RENEWED,
            size: TEXT_SIZE.CAPTION3,
            fontType: TEXT_FONT_WEIGHT.REGULAR,
            color: TEXT_COLOR.GREY5
          }
        }
      }
    }
    infoToShow.href = `/area-cliente/mis-productos/consumos/detalle?productId=${accumulatedUsagesData.productId}&period=${period}`;

    let usages = [];
    let voice = accumulatedUsagesData?.period?.[period]?.voice;
    let data = accumulatedUsagesData?.period?.[period]?.data;
    let sms = accumulatedUsagesData?.period?.[period]?.sms;
    let dataRoaming = accumulatedUsagesData?.period?.[period]?.dataRoaming;

    let allBonusData = [];
    let allBonusVoice = [];
    let allBonusSms = [];

    const isProductSharedData = productSharedData && Array.isArray(productSharedData) && productSharedData.length > 0;

    if ((!idTarifa || idTarifa !== PREPAID_TARIFFS.HABLA_6) && !expiredTariff) {
      if (!isProductSharedData) {
        allBonusData = getAllBonusDataByAccumulated(data);
      }
      allBonusVoice = getAllBonusVoiceByAccumulated(voice);
      allBonusSms = getAllBonusSmsByAccumulated(sms);
    }

    if (dataRoaming) {
      dataRoaming.type = USAGE_TYPES.datos;
      dataRoaming.currentInKb = dataRoaming.current;
      dataRoaming.maxValueInKb = dataRoaming.maxValue;
      dataRoaming.mainTitle = USAGE_TEXT.Roaming2;
      dataRoaming.unit = dataRoaming.current === 0 ? USAGE_TEXT.kb : "";
      dataRoaming.current = transformKbtoData(dataRoaming.current);
      dataRoaming.maxValue = transformKbtoData(dataRoaming.maxValue);
      if (dataRoaming.ppu) {
        dataRoaming.ppu.unit =
          dataRoaming.ppu.current === 0 ? USAGE_TEXT.kb : "";
        dataRoaming.ppu.current = transformKbtoData(dataRoaming.ppu.current);
        dataRoaming.ppu.maxValue = transformKbtoData(dataRoaming.ppu.maxValue);
      }
    }

    if (isProductSharedData && data) {
      const current = transformKbtoData(data.current);
      const unit = data.current === 0 ? USAGE_TEXT.kb : "";
      productSharedData[0].textUnderUsageBar = `${current}${unit ? ` ${unit}` : ''} esta línea`
    }

    if (productData.kindProduct !== allKindProduct.tv) {
      usages.push(...allBonusVoice);
      if (productData.kindProduct !== allKindProduct.phone) {
        usages.push(...allBonusData);
        isProductSharedData && usages.push(...productSharedData);
        dataRoaming && usages.push(dataRoaming);
        usages.push(...allBonusSms);
      }
    } else if (productData.kindProduct === allKindProduct.tv) {
      infoToShow.TV = accumulatedUsagesData.period[period].others.current;
    }

    infoToShow.usages = usages;
    infoToShow.extra = accumulatedUsagesData.period[period]?.totalExtra;
    products = infoToShow;
  }

  return products;
};

export const generateAccumulatedProduct = (accumulatedUsage, period) => {
  let usages = null;

  if (accumulatedUsage) {
    const idTarifa = accumulatedUsage?.period?.[period]?.id || "";
    const expiredTariff = accumulatedUsage?.period?.[period]?.expired || false;
    let infoToShow = {
      href: `/area-cliente/mis-productos/consumos/detalle?productId=${accumulatedUsage.productId}&period=${period}`,
      usages: [],
      idTarifa,
      expired: expiredTariff,
    };
    if (idTarifa === PREPAID_TARIFFS.HABLA_6 || expiredTariff) {
      infoToShow.additionalMessage = {
        text: PREPAID_TARIFFS_NOT_USAGES,
      };
    }
    let voice = accumulatedUsage.period[period].voice;
    let data = accumulatedUsage.period[period].data;

    let allBonusVoiceConsumed = [];
    let dataUsages = null;

    if ((!idTarifa || idTarifa !== PREPAID_TARIFFS.HABLA_6) && !expiredTariff) {
      const allBonusVoice = getAllBonusVoiceByAccumulated(voice);
      allBonusVoiceConsumed =
        Array.isArray(allBonusVoice) && allBonusVoice.length > 0
          ? allBonusVoice.map((bonus) => ({
              ...bonus,
              consumed: true,
            }))
          : [];

      dataUsages = getDataUsagesByAccumulated(data);
    }

    if (accumulatedUsage.kindProduct !== allKindProduct.tv) {
      infoToShow.usages.push(...allBonusVoiceConsumed);
      if (accumulatedUsage.kindProduct !== allKindProduct.phone) {
        dataUsages && infoToShow.usages.push(dataUsages);
      }
    }
    infoToShow.extra = accumulatedUsage.period[period]?.totalExtra;
    usages = infoToShow;
  }

  return usages;
};

export const getOptionsdetailedUsages = (kindProduct) => {
  let options = [];

  if (kindProduct === "mobile") {
    options = [
      { label: "Llamadas", value: 0 },
      { label: "Datos y roaming", value: 1 },
      { label: "Mensajes", value: 2 },
      { label: "Otros consumos", value: 3 },
    ];
  } else if (kindProduct === "phone") {
    options = [
      { label: "Llamadas", value: 0 },
      { label: "Otros consumos", value: 1 },
    ];
  } else if (kindProduct === "tv") {
    options = [{ label: "Otros consumos", value: 0 }];
  }

  return options;
};

export const generateProductsSharedData = (accumulatedUsagesData, period) => {
  let maxValueShared = -1;
  let currentShareUsed = -1;
  const products = [];

  const data = {
    current: -1,
    maxValue: -1,
    unit: "",
    mainTitle: "",
    currentInKb: -1,
    maxValueInKb: -1,
    textUnderUsageBar: "",
  };

  accumulatedUsagesData.forEach((usage) => {
    if (usage.kindProduct === "mobile") {
      if (period !== undefined && period !== null) {
        if (usage && Array.isArray(usage.period) && usage.period.length > 0 && usage.period[period]?.data?.currentShared !== -2) {
          if (maxValueShared === -1 && currentShareUsed === -1) {
            maxValueShared = usage.period[period]?.data?.maxValue;
            currentShareUsed = usage.period[period]?.data?.currentShared;
          }
        }
      } else if (usage.data.currentShared !== -2) {
        if (maxValueShared === -1 && currentShareUsed === -1) {
          maxValueShared = usage.data.maxValue;
          currentShareUsed = usage.data.currentShared;
        }
      }
    }
  });

  data.mainTitle = USAGE_TEXT.sharedData;
  data.type = USAGE_TYPES.datos;
  data.currentInKb = currentShareUsed;
  data.maxValueInKb = maxValueShared;
  data.unit = currentShareUsed === 0 ? USAGE_TEXT.kb : "";
  data.current = transformKbtoData(currentShareUsed);
  data.maxValue = transformKbtoData(maxValueShared);

  products.push(data);

  return products;
};

/* END OF AUXILIAR FUNCTIONS FOR DATA SHARING */
